import { getApiHeaders } from '../../utils/apiHelpers';

export const API_ARCHIVIO = `${process.env.REACT_APP_BACKEND_URL}/api/gestione/ddt-archivio`;

export const urlScansione = (ddtId, download = false) => {
  const params = new URLSearchParams({ tenant: getApiHeaders()['X-Tenant-DB'] || '' });
  if (download) params.append('download', 'true');
  return `${API_ARCHIVIO}/${ddtId}/scansione?${params.toString()}`;
};

export const mb = (b) => `${(b / 1048576).toLocaleString('it-IT', { maximumFractionDigits: 1, minimumFractionDigits: b ? 1 : 0 })} MB`;

export const dataItaliana = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : null);
